import { Component, Injectable } from "@angular/core";
import { GridsterItem } from "angular-gridster2";
import { WidgetService } from "../../services/widget/widget.service";

export interface DashboardWidget {
	name: string;
	type: string;
	config: any;
	component: any;
	description?: string;
	gridsterItem: GridsterItem;
}

@Injectable({
	providedIn: "root",
})
export class DashboardWidgetFactory {
	constructor(private widgetRegistry: WidgetService) {}

	createWidget(
		type: string,
		x: number = 0,
		y: number = 0,
		config?: any
	): DashboardWidget {
		const { name, cols, rows, component } =
			this.widgetRegistry.getWidgetDefinition(type);
		return {
			type,
			name: name || "",
			config: config,
			component: component,
			gridsterItem: { cols: cols, rows: rows, x: x || 0, y: y || 0 },
		};
	}
}
